import { render, staticRenderFns } from "./ProgressBar.vue?vue&type=template&id=2222c7b0&scoped=true"
import script from "./ProgressBar.vue?vue&type=script&lang=js"
export * from "./ProgressBar.vue?vue&type=script&lang=js"
import style0 from "./ProgressBar.vue?vue&type=style&index=0&id=2222c7b0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2222c7b0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2222c7b0')) {
      api.createRecord('2222c7b0', component.options)
    } else {
      api.reload('2222c7b0', component.options)
    }
    module.hot.accept("./ProgressBar.vue?vue&type=template&id=2222c7b0&scoped=true", function () {
      api.rerender('2222c7b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/components/ProgressBar.vue"
export default component.exports